import { render, staticRenderFns } from "./BrandVatdEdit.vue?vue&type=template&id=67d944cc&"
import script from "./BrandVatdEdit.vue?vue&type=script&lang=js&"
export * from "./BrandVatdEdit.vue?vue&type=script&lang=js&"
import style0 from "./BrandVatdEdit.vue?vue&type=style&index=0&id=67d944cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports